document.documentElement.classList.remove('no-js')

function initialiseHeroVideos(root = document) {
  root.querySelectorAll('.hero__media:not([data-hero-video-ready])').forEach((video) => {
    video.dataset.heroVideoReady = 'true'
    video.muted = true
    video.defaultMuted = true
    video.playsInline = true
    video.setAttribute('muted', '')
    video.setAttribute('playsinline', '')
    video.setAttribute('webkit-playsinline', '')
    video.setAttribute('preload', 'auto')

    const playWhenPossible = () => {
      const style = window.getComputedStyle(video)
      if (style.display === 'none' || video.offsetParent === null) return
      video.play().catch(() => {})
    }

    video.addEventListener('loadeddata', playWhenPossible, { once: true })
    video.addEventListener('canplay', playWhenPossible, { once: true })
    requestAnimationFrame(playWhenPossible)
  })
}

initialiseHeroVideos()
document.addEventListener('DOMContentLoaded', () => initialiseHeroVideos())
document.addEventListener('shopify:section:load', (event) => initialiseHeroVideos(event.target))

function ensureProductLabNav() {
  const nav = document.querySelector('.site-header__links')
  if (!nav || nav.querySelector('.site-header__dropdown')) return
  const hasLab = [...nav.querySelectorAll('a')].some((link) => {
    const label = link.textContent.trim().toLowerCase()
    return label === 'product lab' || label === 'work lab'
  })
  if (hasLab) return

  const dropdown = document.createElement('details')
  dropdown.className = 'site-header__dropdown'
  dropdown.innerHTML = `
    <summary><span>work lab</span><span aria-hidden="true">⌄</span></summary>
    <div class="site-header__dropdown-menu">
      <a href="/pages/fabric-guide">Fabric Guide</a>
      <a href="/pages/craft-library">Craft Library</a>
      <a href="/pages/case-studies?ntk=worklab">Case Studies</a>
    </div>
  `
  nav.append(dropdown)
}

document.addEventListener('DOMContentLoaded', ensureProductLabNav)

function updateBlankBase(section) {
  const product = section?.querySelector('[data-blank-product].is-active')
  const fit = section?.querySelector('[data-blank-fit-select] option:checked')
  const side = section?.querySelector('[data-blank-side].is-active')?.dataset.blankSide || 'front'
  const image = section?.querySelector('[data-blank-base]')
  const fallback = section?.querySelector('[data-blank-fallback]')
  if (!product || !image || !fallback) return

  const front = fit?.dataset.frontImage || product.dataset.frontImage || ''
  const back = fit?.dataset.backImage || product.dataset.backImage || ''
  const source = side === 'back' ? (back || front) : front

  if (source) {
    image.src = source
    image.alt = `${product.dataset.blankProduct} ${side} mockup`
    image.hidden = false
    fallback.hidden = true
    image.closest('[data-garment-shape]')?.classList.add('blank-preview__shape--image')
  } else {
    image.removeAttribute('src')
    image.alt = ''
    image.hidden = true
    fallback.hidden = false
    image.closest('[data-garment-shape]')?.classList.remove('blank-preview__shape--image')
  }
}

function updateBlankFits(section, product) {
  const select = section?.querySelector('[data-blank-fit-select]')
  if (!select || !product) return
  const fits = [...product.querySelectorAll('[data-blank-fit]')]
  select.replaceChildren(...fits.map((fit, index) => {
    const option = document.createElement('option')
    option.value = `fit-${index + 1}`
    option.textContent = fit.dataset.fitName || `Fit ${index + 1}`
    option.dataset.frontImage = fit.dataset.frontImage || ''
    option.dataset.backImage = fit.dataset.backImage || ''
    return option
  }))
  updateBlankBase(section)
}

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('.site-header__toggle')
  if (toggle) {
    const menu = document.getElementById(toggle.getAttribute('aria-controls'))
    const open = toggle.getAttribute('aria-expanded') === 'true'
    toggle.setAttribute('aria-expanded', String(!open))
    menu?.classList.toggle('is-open', !open)
  }

  const choice = event.target.closest('[data-choice]')
  if (choice) {
    choice.parentElement?.querySelectorAll('[data-choice]').forEach((item) => item.classList.remove('is-active'))
    choice.classList.add('is-active')
    if (choice.dataset.colour) {
      const fill = choice.closest('[data-blank-builder-section]')?.querySelector('[data-garment-fill]')
      if (fill) fill.setAttribute('fill', choice.dataset.colour)
    }
    if (choice.dataset.blankSide) updateBlankBase(choice.closest('[data-blank-builder-section]'))
  }

  const product = event.target.closest('[data-blank-product]')
  if (product) {
    product.parentElement?.querySelectorAll('[data-blank-product]').forEach((item) => item.classList.remove('is-active'))
    product.classList.add('is-active')
    const section = product.closest('[data-blank-builder-section]')
    updateBlankFits(section, product)
    const shape = section?.querySelector('[data-garment-shape]')
    if (shape && window.gsap) window.gsap.fromTo(shape, { opacity: 0.35, scale: 0.94 }, { opacity: 1, scale: 1, duration: 0.45, ease: 'power2.out' })
  }

  const craftButton = event.target.closest('[data-craft-prev], [data-craft-next]')
  if (craftButton) {
    const section = craftButton.closest('#craft')
    const track = section?.querySelector('[data-craft-track]')
    const card = track?.querySelector('.craft-card')
    if (track && card) {
      const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0
      const direction = craftButton.hasAttribute('data-craft-prev') ? -1 : 1
      track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' })
    }
  }
})

document.addEventListener('change', (event) => {
  const fitSelect = event.target.closest('[data-blank-fit-select]')
  if (fitSelect) {
    const section = fitSelect.closest('[data-blank-builder-section]')
    updateBlankBase(section)
    const shape = section?.querySelector('[data-garment-shape]')
    if (shape && window.gsap) window.gsap.fromTo(shape, { opacity: 0.35, scale: 0.94 }, { opacity: 1, scale: 1, duration: 0.4, ease: 'power2.out' })
    return
  }

  const contactFile = event.target.closest('[data-contact-file]')
  if (contactFile) {
    const file = contactFile.files?.[0]
    const name = contactFile.closest('.contact-upload')?.querySelector('[data-contact-file-name]')
    if (file && file.size > 20 * 1024 * 1024) {
      contactFile.value = ''
      if (name) name.textContent = 'file exceeds 20 MB'
      return
    }
    if (name) name.textContent = file?.name || 'no file selected'
  }

  const input = event.target.closest('[data-artwork-upload]')
  if (!input || !input.files?.[0]) return
  const section = input.closest('[data-blank-builder-section]')
  const preview = section?.querySelector('[data-artwork-preview]')
  const tools = section?.querySelector('[data-artwork-tools]')
  const scale = section?.querySelector('[data-artwork-scale]')
  if (!preview) return
  if (preview.dataset.objectUrl) URL.revokeObjectURL(preview.dataset.objectUrl)
  const url = URL.createObjectURL(input.files[0])
  preview.src = url
  preview.dataset.objectUrl = url
  preview.style.left = '50%'
  preview.style.top = '48%'
  preview.style.width = '25%'
  preview.style.transform = 'translate(-50%,-50%)'
  preview.hidden = false
  if (scale) scale.value = '25'
  if (tools) tools.hidden = false
})

document.addEventListener('input', (event) => {
  const scale = event.target.closest('[data-artwork-scale]')
  if (!scale) return
  const preview = scale.closest('[data-blank-builder-section]')?.querySelector('[data-artwork-preview]')
  if (preview && !preview.hidden) preview.style.width = `${scale.value}%`
})

document.addEventListener('click', (event) => {
  const reset = event.target.closest('[data-artwork-reset]')
  if (!reset) return
  const section = reset.closest('[data-blank-builder-section]')
  const preview = section?.querySelector('[data-artwork-preview]')
  const scale = section?.querySelector('[data-artwork-scale]')
  if (!preview || preview.hidden) return
  preview.style.left = '50%'
  preview.style.top = '48%'
  preview.style.width = '25%'
  preview.style.transform = 'translate(-50%,-50%)'
  if (scale) scale.value = '25'
})

document.querySelectorAll('[data-artwork-preview]').forEach((art) => {
  let drag = null
  art.addEventListener('pointerdown', (event) => {
    event.preventDefault()
    event.stopPropagation()
    const canvas = art.closest('.blank-preview')
    if (!canvas) return
    const bounds = canvas.getBoundingClientRect()
    drag = { bounds }
    art.setPointerCapture(event.pointerId)
  })
  art.addEventListener('pointermove', (event) => {
    if (!drag) return
    event.preventDefault()
    const x = Math.max(0, Math.min(100, ((event.clientX - drag.bounds.left) / drag.bounds.width) * 100))
    const y = Math.max(0, Math.min(100, ((event.clientY - drag.bounds.top) / drag.bounds.height) * 100))
    art.style.left = `${x}%`
    art.style.top = `${y}%`
    art.style.transform = 'translate(-50%,-50%)'
  })
  art.addEventListener('pointerup', () => { drag = null })
  art.addEventListener('pointercancel', () => { drag = null })
})

const craftVideoObserver = 'IntersectionObserver' in window
  ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) entry.target.play().catch(() => {})
        else entry.target.pause()
      })
    }, { threshold: 0.45 })
  : null

function initialiseCraftVideos(root = document) {
  root.querySelectorAll('.craft-card__video:not([data-craft-observed])').forEach((video) => {
    video.dataset.craftObserved = 'true'
    video.muted = true
    if (craftVideoObserver) craftVideoObserver.observe(video)
  })
}

function initialiseCraftTracks(root = document) {
  root.querySelectorAll('[data-craft-track]:not([data-drag-ready])').forEach((track) => {
    track.dataset.dragReady = 'true'
    let drag = null
    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse') return
      drag = { x: event.clientX, left: track.scrollLeft }
      track.setPointerCapture(event.pointerId)
    })
    track.addEventListener('pointermove', (event) => {
      if (!drag) return
      track.scrollLeft = drag.left - (event.clientX - drag.x)
    })
    track.addEventListener('pointerup', () => { drag = null })
    track.addEventListener('pointercancel', () => { drag = null })
  })
}

function initialiseCraftSection(root = document) {
  initialiseCraftVideos(root)
  initialiseCraftTracks(root)
}

initialiseCraftSection()
document.addEventListener('shopify:section:load', (event) => initialiseCraftSection(event.target))

function getQuoteEndpoint(form) {
  return (form?.closest('[data-quote-endpoint]')?.dataset.quoteEndpoint || '').trim()
}

function getFieldValue(form, names) {
  for (const name of names) {
    const field = form.querySelector(`[name="contact[${name}]"]`)
    if (field && typeof field.value === 'string' && field.value.trim()) return field.value.trim()
  }
  return ''
}

function setBriefFormStatus(form, message, isError = false) {
  let status = form.querySelector('[data-quote-brief-status]')
  if (!status) {
    status = document.createElement('p')
    status.dataset.quoteBriefStatus = ''
    status.className = form.classList.contains('contact-form') ? 'form-status' : 'full-custom-micro-form__status'
    const button = form.querySelector('[type="submit"]')
    if (button?.parentElement?.classList.contains('full-custom-micro-form__actions')) {
      button.parentElement.insertAdjacentElement('beforebegin', status)
    } else if (button) {
      button.insertAdjacentElement('beforebegin', status)
    } else {
      form.append(status)
    }
  }
  status.textContent = message
  status.classList.toggle('full-custom-micro-form__status--error', Boolean(isError))
  status.classList.toggle('form-status--error', Boolean(isError))
}

function buildBriefPayload(form) {
  const attachment = form.querySelector('input[type="file"]')?.files?.[0]
  const title = form.dataset.quoteTitle || 'Website enquiry'
  const source = form.dataset.quoteSource || 'website-form'
  const name = getFieldValue(form, ['name'])
  const contact = getFieldValue(form, ['contact'])
  const email = getFieldValue(form, ['email']) || (contact.includes('@') ? contact : '')
  const phone = getFieldValue(form, ['phone', 'whatsapp']) || (!contact.includes('@') ? contact : '')
  const brand = getFieldValue(form, ['brand'])
  const route = getFieldValue(form, ['route'])
  const quantity = getFieldValue(form, ['quantity'])
  const artworkLink = getFieldValue(form, ['artwork_link'])
  const message = getFieldValue(form, ['body'])

  const options = [
    `Source: ${source}`,
    brand ? `Brand: ${brand}` : '',
    route ? `Project route: ${route}` : '',
    quantity ? `Target quantity: ${quantity}` : '',
    artworkLink ? `Artwork/reference link: ${artworkLink}` : '',
    attachment ? `Attached file name: ${attachment.name}` : '',
    message ? `Message: ${message}` : ''
  ].filter(Boolean)

  return {
    source,
    submittedAt: new Date().toISOString(),
    customer: { name, email, whatsapp: phone || contact },
    product: {
      title,
      handle: source,
      url: window.location.href.split('#')[0] + (source.includes('contact') ? '#contact' : source.includes('why-ntkeee') ? '#why-ntkeee-brief' : '#full-custom')
    },
    selection: {
      product: title,
      productUrl: window.location.href,
      quantity: quantity || 1,
      technique: 'Full custom enquiry',
      options,
      front: attachment ? { fileName: attachment.name, note: 'Original file is not stored in Shopify draft order. Ask customer to send via WhatsApp/email if needed.' } : null,
      back: null,
      message
    }
  }
}

async function submitBriefQuote(form, payload) {
  const endpoint = getQuoteEndpoint(form)
  if (!endpoint) throw new Error('Quote endpoint is not configured.')
  const isAppsScript = endpoint.includes('script.google.com/macros/s/')
  const response = await fetch(endpoint, {
    method: 'POST',
    mode: isAppsScript ? 'no-cors' : 'cors',
    headers: { 'Content-Type': 'text/plain;charset=utf-8' },
    body: JSON.stringify(payload)
  })
  if (isAppsScript) return { ok: true }
  const result = await response.json().catch(() => ({}))
  if (!response.ok || result.ok === false) throw new Error(result.error || 'Quote request failed.')
  return result
}

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-quote-brief-form]')
  if (!form) return
  event.preventDefault()

  const submit = form.querySelector('[type="submit"]')
  const originalHtml = submit?.innerHTML
  const payload = buildBriefPayload(form)
  if (!payload.customer.name || !(payload.customer.email || payload.customer.whatsapp)) {
    setBriefFormStatus(form, 'Please add your name and one contact method.', true)
    return
  }

  try {
    if (submit) {
      submit.disabled = true
      submit.innerHTML = 'sending… <span>↗</span>'
    }
    setBriefFormStatus(form, 'Creating your quote request…')
    await submitBriefQuote(form, payload)
    setBriefFormStatus(form, 'Quote request created. We will review it and contact you.')
    form.reset()
    form.querySelectorAll('[data-contact-file-name]').forEach((node) => { node.textContent = 'no file selected' })
    form.querySelectorAll('[data-full-custom-file-label]').forEach((node) => { node.textContent = 'attach file' })
  } catch (error) {
    setBriefFormStatus(form, error?.message || 'Could not create quote request. Please WhatsApp or email us.', true)
  } finally {
    if (submit) {
      submit.disabled = false
      submit.innerHTML = originalHtml
    }
  }
})

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max)
}

function formatMoney(cents) {
  if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents)
  return `$${(Number(cents || 0) / 100).toFixed(2)}`
}

function replaceInputFile(input, file) {
  if (!input || !file || typeof DataTransfer === 'undefined') return
  const transfer = new DataTransfer()
  transfer.items.add(file)
  input.files = transfer.files
}

async function removeSolidBackground(file) {
  const bitmap = await createImageBitmap(file)
  const maxSide = 1600
  const ratio = Math.min(1, maxSide / Math.max(bitmap.width, bitmap.height))
  const width = Math.max(1, Math.round(bitmap.width * ratio))
  const height = Math.max(1, Math.round(bitmap.height * ratio))
  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height
  const context = canvas.getContext('2d', { willReadFrequently: true })
  context.drawImage(bitmap, 0, 0, width, height)
  bitmap.close?.()

  const image = context.getImageData(0, 0, width, height)
  const pixels = image.data
  const corners = [
    0,
    (width - 1) * 4,
    (height - 1) * width * 4,
    ((height - 1) * width + width - 1) * 4
  ]
  const background = corners.reduce((colour, index) => {
    colour[0] += pixels[index]
    colour[1] += pixels[index + 1]
    colour[2] += pixels[index + 2]
    return colour
  }, [0, 0, 0]).map((channel) => channel / corners.length)

  const threshold = 46
  const feather = 34
  for (let index = 0; index < pixels.length; index += 4) {
    if (pixels[index + 3] === 0) continue
    const red = pixels[index] - background[0]
    const green = pixels[index + 1] - background[1]
    const blue = pixels[index + 2] - background[2]
    const distance = Math.sqrt(red * red + green * green + blue * blue)
    if (distance <= threshold) pixels[index + 3] = 0
    else if (distance < threshold + feather) {
      pixels[index + 3] = Math.round(pixels[index + 3] * ((distance - threshold) / feather))
    }
  }
  context.putImageData(image, 0, 0)

  const blob = await new Promise((resolve, reject) => {
    canvas.toBlob((result) => result ? resolve(result) : reject(new Error('Unable to process artwork')), 'image/png')
  })
  const name = `${file.name.replace(/\.[^.]+$/, '')}-transparent.png`
  return new File([blob], name, { type: 'image/png' })
}

function initialiseProductCustomizers(root = document) {
  root.querySelectorAll('[data-product-customizer]:not([data-customizer-ready])').forEach((section) => {
    section.dataset.customizerReady = 'true'
    const stage = section.querySelector('[data-customizer-stage]')
    const printArea = section.querySelector('[data-customizer-print-area]')
    const artwork = section.querySelector('[data-customizer-artwork]')
    const artworkImage = section.querySelector('[data-customizer-artwork-image]')
    const base = section.querySelector('[data-customizer-base]')
    const viewLabel = section.querySelector('[data-customizer-view-label]')
    const status = section.querySelector('[data-customizer-status]')
    const form = section.querySelector('[data-customizer-form]')
    const configuration = section.querySelector('[data-customizer-configuration]')
    const variantInput = section.querySelector('[data-customizer-variant]')
    const quantityInput = section.querySelector('[data-customizer-quantity]')
    const unitPrice = section.querySelector('[data-customizer-unit-price]')
    const totalPrice = section.querySelector('[data-customizer-total-price]')
    const details = section.querySelector('[data-product-details]')
    const galleryThumbnails = [...section.querySelectorAll('[data-gallery-image]')]
    if (!stage || !printArea || !artwork || !artworkImage || !form || !configuration) return

    const variants = JSON.parse(section.querySelector('[data-customizer-variants]')?.textContent || '[]')
    const media = JSON.parse(section.querySelector('[data-customizer-media]')?.textContent || '[]')
    const selectedOptions = [...section.querySelectorAll('[data-customizer-option]')].map((group) => {
      const active = group.querySelector('[data-customizer-option-value].is-active') || group.querySelector('[data-customizer-option-value]')
      return active?.dataset.customizerOptionValue || ''
    })

    const sides = {
      front: { x: 50, y: 42, width: 30, ratio: null, file: null, url: '' },
      back: { x: 50, y: 42, width: 30, ratio: null, file: null, url: '' }
    }
    let activeSide = 'front'
    let selectedVariant = variants.find((variant) => String(variant.id) === variantInput?.value) || variants[0] || null
    let pointer = null
    let galleryMode = stage.classList.contains('is-gallery-mode') && galleryThumbnails.length > 0

    const setStatus = (message) => { if (status) status.textContent = message }

    const cleanDetails = () => {
      if (!details || details.dataset.detailsCleaned) return
      details.dataset.detailsCleaned = 'true'
      details.querySelectorAll('p, li').forEach((node) => {
        const text = node.textContent.toLowerCase()
        if (text.includes('us$') || text.includes('$') || text.includes('sample:') || text.includes('bulk:') || text.includes('moq') || text.includes('quoted separately')) {
          node.remove()
        }
      })
    }

    const renderArtwork = () => {
      const current = sides[activeSide]
      if (!current.url) {
        artwork.hidden = true
        artwork.style.removeProperty('aspect-ratio')
        artwork.style.removeProperty('height')
        artworkImage.style.removeProperty('height')
        artworkImage.onload = null
        artworkImage.removeAttribute('src')
        return
      }
      artwork.hidden = false
      const applyNaturalRatio = () => {
        if (artworkImage.naturalWidth && artworkImage.naturalHeight) {
          current.ratio = artworkImage.naturalWidth / artworkImage.naturalHeight
          artwork.style.aspectRatio = `${artworkImage.naturalWidth} / ${artworkImage.naturalHeight}`
        } else if (current.ratio) {
          artwork.style.aspectRatio = String(current.ratio)
        } else {
          artwork.style.removeProperty('aspect-ratio')
        }
        artwork.style.height = 'auto'
        artworkImage.style.width = '100%'
        artworkImage.style.height = 'auto'
      }
      artworkImage.onload = applyNaturalRatio
      if (artworkImage.src !== current.url) artworkImage.src = current.url
      if (artworkImage.complete) applyNaturalRatio()
      artwork.style.left = `${current.x}%`
      artwork.style.top = `${current.y}%`
      artwork.style.width = `${current.width}%`
    }

    const renderSide = () => {
      galleryMode = false
      stage.classList.remove('is-gallery-mode')
      galleryThumbnails.forEach((thumbnail) => {
        thumbnail.classList.remove('is-active')
        thumbnail.setAttribute('aria-pressed', 'false')
      })
      const variantImage = selectedVariant?.featuredImage || ''
      const defaultFront = stage.dataset.defaultFrontImage || stage.dataset.frontImage || ''
      const defaultBack = stage.dataset.defaultBackImage || stage.dataset.backImage || defaultFront
      const mediaForView = findMediaForView()
      const source = activeSide === 'back'
        ? (mediaForView || defaultBack || variantImage || defaultFront)
        : (mediaForView || variantImage || defaultFront)
      if (base && source) {
        base.src = source
        base.alt = `${section.dataset.productTitle || 'Product'} ${activeSide} mockup`
      }
      if (viewLabel) viewLabel.textContent = `${activeSide} view`
      section.querySelectorAll('[data-customizer-side]').forEach((button) => {
        button.classList.toggle('is-active', button.dataset.customizerSide === activeSide)
      })
      section.querySelectorAll('[data-customizer-upload-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.customizerUploadPanel !== activeSide
      })
      renderArtwork()
      setStatus('')
    }

    const renderGalleryImage = (thumbnail) => {
      const source = thumbnail.dataset.galleryImage || ''
      if (!base || !source) return
      galleryMode = true
      stage.classList.add('is-gallery-mode')
      base.src = source
      base.alt = thumbnail.dataset.galleryAlt || section.dataset.productTitle || 'Product image'
      galleryThumbnails.forEach((item) => {
        const active = item === thumbnail
        item.classList.toggle('is-active', active)
        item.setAttribute('aria-pressed', String(active))
      })
      section.querySelectorAll('[data-customizer-side]').forEach((button) => {
        button.classList.remove('is-active')
      })
      setStatus('')
    }

    const getSelectedColour = () => {
      const colourGroup = section.querySelector('[data-option-kind="colour"]')
      return colourGroup?.querySelector('[data-customizer-option-value].is-active')?.dataset.customizerOptionValue || ''
    }

    const getCustomizerParts = (item) => {
      const altParts = String(item.alt || '').toLowerCase().split('|').map((part) => part.trim())
      if (altParts[0] === 'customizer' && altParts[1] && altParts[2]) return altParts
      const rawUrl = String(item.url || '')
      const decodedUrl = (() => {
        try {
          return decodeURIComponent(rawUrl)
        } catch (_error) {
          return rawUrl
        }
      })()
      const filename = decodedUrl.split('/').pop().split('?')[0].toLowerCase().replace(/\.[^.]+$/, '')
      const filenameParts = filename.split('__').map((part) => part.replace(/[-_]+/g, ' ').trim())
      return filenameParts[0] === 'customizer' ? filenameParts : []
    }

    const findMediaForView = () => {
      const colour = getSelectedColour().toLowerCase()
      if (!colour) return ''
      const side = activeSide.toLowerCase()
      const colourToken = colour.replace(/\s+/g, ' ').trim()
      const exact = media.find((item) => {
        const parts = getCustomizerParts(item)
        return parts[0] === 'customizer' && parts[1] === colourToken && parts[2] === side
      })
      return exact?.url || ''
    }

    const findVariant = () => {
      if (!selectedOptions.length) return variants[0] || null
      return variants.find((variant) => (
        variant.options.length === selectedOptions.length &&
        variant.options.every((option, index) => option === selectedOptions[index])
      )) || null
    }

    const renderOptions = (activateCustomizer = true) => {
      section.querySelectorAll('[data-customizer-option]').forEach((group, groupIndex) => {
        group.querySelectorAll('[data-customizer-option-value]').forEach((button) => {
          const active = button.dataset.customizerOptionValue === selectedOptions[groupIndex]
          button.classList.toggle('is-active', active)
          button.setAttribute('aria-pressed', String(active))
        })
      })

      selectedVariant = findVariant()
      if (variantInput && selectedVariant) variantInput.value = selectedVariant.id
      if (unitPrice && selectedVariant) unitPrice.textContent = selectedVariant.priceText || formatMoney(selectedVariant.price)
      if (totalPrice && selectedVariant) {
        const quantity = Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1)
        totalPrice.textContent = formatMoney(selectedVariant.price * quantity)
      }
      if (form) form.toggleAttribute('data-unavailable', !selectedVariant?.available)
      const submit = form.querySelector('[type="submit"]')
      if (submit) submit.disabled = !selectedVariant?.available
      if (activateCustomizer) renderSide()
    }

    const setArtwork = (side, file) => {
      const current = sides[side]
      if (current.url) URL.revokeObjectURL(current.url)
      current.file = file
      current.url = URL.createObjectURL(file)
      current.ratio = null
      const input = section.querySelector(`[data-customizer-upload-side="${side}"]`)
      const label = input?.closest('.product-customizer__upload')?.querySelector('[data-customizer-file-label]')
      if (label) label.textContent = file.name
      if (side === activeSide) renderSide()
    }

    galleryThumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => renderGalleryImage(thumbnail))
    })

    section.querySelectorAll('[data-customizer-side]').forEach((button) => {
      button.addEventListener('click', () => {
        activeSide = button.dataset.customizerSide || 'front'
        renderSide()
      })
    })

    section.querySelectorAll('[data-customizer-option-value]').forEach((button) => {
      button.addEventListener('click', () => {
        const group = button.closest('[data-customizer-option]')
        const position = Number.parseInt(group?.dataset.optionPosition || '1', 10) - 1
        selectedOptions[position] = button.dataset.customizerOptionValue || ''
        const colourChanged = group?.dataset.optionKind === 'colour'
        renderOptions(colourChanged || !galleryMode)
      })
    })

    section.querySelectorAll('[data-customizer-upload]').forEach((input) => {
      input.addEventListener('change', () => {
        const file = input.files?.[0]
        if (!file) return
        if (file.size > 20 * 1024 * 1024) {
          input.value = ''
          setStatus('Please upload an artwork file smaller than 20 MB.')
          return
        }
        setArtwork(input.dataset.customizerUploadSide || activeSide, file)
        setStatus('Artwork loaded. Drag it into position on the mockup.')
      })
    })

    section.querySelectorAll('[data-customizer-remove-bg]').forEach((button) => {
      button.addEventListener('click', async () => {
        const input = section.querySelector(`[data-customizer-upload-side="${activeSide}"]`)
        const file = sides[activeSide].file || input?.files?.[0]
        if (!file) {
          setStatus('Upload artwork before removing its background.')
          return
        }
        button.disabled = true
        setStatus('Removing the solid background in your browser…')
        try {
          const processed = await removeSolidBackground(file)
          replaceInputFile(input, processed)
          setArtwork(activeSide, processed)
          setStatus('Background removed. Best results come from a clean, solid background.')
        } catch (error) {
          setStatus('Background removal could not process this file. Try a PNG or JPG with a solid background.')
        } finally {
          button.disabled = false
        }
      })
    })

    quantityInput?.addEventListener('input', () => renderOptions(!galleryMode))

    section.querySelectorAll('input[name="properties[Technique]"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        section.querySelectorAll('.product-customizer__choice').forEach((label) => {
          label.classList.toggle('is-active', Boolean(label.querySelector('input:checked')))
        })
      })
    })

    artwork.addEventListener('pointerdown', (event) => {
      event.preventDefault()
      const current = sides[activeSide]
      pointer = {
        id: event.pointerId,
        mode: event.target.closest('[data-customizer-resize]') ? 'resize' : 'drag',
        startX: event.clientX,
        startY: event.clientY,
        x: current.x,
        y: current.y,
        width: current.width
      }
      artwork.setPointerCapture(event.pointerId)
    })

    artwork.addEventListener('pointermove', (event) => {
      if (!pointer || pointer.id !== event.pointerId) return
      const bounds = printArea.getBoundingClientRect()
      const current = sides[activeSide]
      const deltaX = ((event.clientX - pointer.startX) / bounds.width) * 100
      const deltaY = ((event.clientY - pointer.startY) / bounds.height) * 100
      if (pointer.mode === 'resize') current.width = clamp(pointer.width + deltaX * 2, 8, 86)
      else {
        current.x = clamp(pointer.x + deltaX, 0, 100)
        current.y = clamp(pointer.y + deltaY, 0, 100)
      }
      renderArtwork()
    })

    const endPointer = (event) => {
      if (!pointer || pointer.id !== event.pointerId) return
      pointer = null
    }
    artwork.addEventListener('pointerup', endPointer)
    artwork.addEventListener('pointercancel', endPointer)

    const getQuoteConfiguration = () => {
      const technique = form.querySelector('input[name="properties[Technique]"]:checked')?.value || ''
      const variant = form.querySelector('[name="id"]')?.value || ''
      const quantity = Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1)
      return {
        version: 1,
        product: section.dataset.productTitle || '',
        productHandle: section.dataset.productHandle || '',
        productUrl: window.location.href.split('?')[0],
        variant,
        variantTitle: selectedVariant?.title || '',
        variantSku: selectedVariant?.sku || '',
        options: selectedOptions,
        quantity,
        technique,
        front: sides.front.file ? { fileName: sides.front.file.name, x: sides.front.x, y: sides.front.y, width: sides.front.width } : null,
        back: sides.back.file ? { fileName: sides.back.file.name, x: sides.back.x, y: sides.back.y, width: sides.back.width } : null
      }
    }

    const buildWhatsAppLink = (payload) => {
      const base = section.dataset.whatsappUrl || 'https://wa.me/8613974119622'
      const lines = [
        'Hi NTKEEE, I just submitted a custom quote request on the website. Please check the Shopify draft order and contact me with pricing.',
        `Product: ${payload.product?.title || section.dataset.productTitle || ''}`,
        `Options: ${(payload.selection?.options || []).filter(Boolean).join(' / ')}`,
        `Size/Variant: ${payload.selection?.variantTitle || ''}`,
        `Technique: ${payload.selection?.technique || ''}`,
        `Quantity: ${payload.selection?.quantity || ''}`,
        `Product URL: ${payload.product?.url || window.location.href.split('?')[0]}`,
        payload.customer?.name ? `Name: ${payload.customer.name}` : '',
        payload.customer?.email ? `Email: ${payload.customer.email}` : '',
        payload.customer?.whatsapp ? `WhatsApp: ${payload.customer.whatsapp}` : ''
      ].filter(Boolean)
      return `${base}?text=${encodeURIComponent(lines.join('\n'))}`
    }

    const openWhatsAppPlaceholder = () => {
      const popup = window.open('', '_blank')
      if (!popup) return null
      popup.document.write('<!doctype html><title>Opening WhatsApp…</title><body style="font-family:Arial,sans-serif;padding:32px;background:#111;color:#fff"><h1>Opening WhatsApp…</h1><p>Your quote request is being submitted first. WhatsApp will open automatically after it is saved.</p></body>')
      popup.document.close()
      return popup
    }

    const openWhatsAppQuoteReminder = (payload, popup) => {
      const link = buildWhatsAppLink(payload)
      if (popup && !popup.closed) {
        popup.location.href = link
        return
      }
      window.open(link, '_blank', 'noopener')
    }

    const loadPreviewImage = (source) => new Promise((resolve, reject) => {
      if (!source) {
        reject(new Error('Missing preview image source'))
        return
      }
      const image = new Image()
      if (!source.startsWith('blob:') && !source.startsWith('data:')) image.crossOrigin = 'anonymous'
      image.onload = () => resolve(image)
      image.onerror = () => reject(new Error('Unable to load preview image'))
      image.src = source
    })

    const drawContain = (context, image, x, y, width, height) => {
      const ratio = Math.min(width / image.naturalWidth, height / image.naturalHeight)
      const drawWidth = image.naturalWidth * ratio
      const drawHeight = image.naturalHeight * ratio
      context.drawImage(image, x + (width - drawWidth) / 2, y + (height - drawHeight) / 2, drawWidth, drawHeight)
    }

    const getMediaForSide = (side) => {
      const colour = getSelectedColour().toLowerCase()
      const colourToken = colour.replace(/\s+/g, ' ').trim()
      const exact = media.find((item) => {
        const parts = getCustomizerParts(item)
        return parts[0] === 'customizer' && parts[1] === colourToken && parts[2] === side
      })
      const variantImage = selectedVariant?.featuredImage || ''
      const defaultFront = stage.dataset.defaultFrontImage || stage.dataset.frontImage || ''
      const defaultBack = stage.dataset.defaultBackImage || stage.dataset.backImage || defaultFront
      return exact?.url || (side === 'back' ? (defaultBack || variantImage || defaultFront) : (variantImage || defaultFront))
    }

    const buildPreviewForSide = async (side) => {
      const current = sides[side]
      if (!current.file || !current.url) return null
      const canvas = document.createElement('canvas')
      const size = 1200
      canvas.width = size
      canvas.height = size
      const context = canvas.getContext('2d')
      context.fillStyle = '#d9d8d2'
      context.fillRect(0, 0, size, size)

      try {
        const baseImage = await loadPreviewImage(getMediaForSide(side))
        drawContain(context, baseImage, 0, 0, size, size)
      } catch (_error) {
        // Keep the neutral stage background if the base image cannot be loaded.
      }

      try {
        const artImage = await loadPreviewImage(current.url)
        const printX = size * 0.27
        const printY = size * 0.21
        const printWidth = size * 0.46
        const printHeight = size * 0.58
        const artWidth = printWidth * (current.width / 100)
        const artHeight = artWidth / (current.ratio || (artImage.naturalWidth / artImage.naturalHeight) || 1)
        const artX = printX + (printWidth * current.x / 100) - artWidth / 2
        const artY = printY + (printHeight * current.y / 100) - artHeight / 2
        context.drawImage(artImage, artX, artY, artWidth, artHeight)
      } catch (_error) {
        return null
      }

      return {
        fileName: `${section.dataset.productHandle || 'ntkeee'}-${side}-preview.jpg`,
        mimeType: 'image/jpeg',
        dataUrl: canvas.toDataURL('image/jpeg', 0.86)
      }
    }

    const buildQuotePreviews = async () => {
      const [front, back] = await Promise.all([
        buildPreviewForSide('front'),
        buildPreviewForSide('back')
      ])
      return { front, back }
    }

    const submitQuoteRequest = async (payload) => {
      const endpoint = (section.dataset.quoteEndpoint || '').trim()
      if (!endpoint) {
        return { ok: true, fallback: 'whatsapp' }
      }

      const isAppsScript = endpoint.includes('script.google.com/macros/s/')
      const response = await fetch(endpoint, {
        method: 'POST',
        mode: isAppsScript ? 'no-cors' : 'cors',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload)
      })

      if (isAppsScript) return { ok: true, fallback: false }
      const result = await response.json().catch(() => ({}))
      if (!response.ok || result.ok === false) throw new Error(result.error || 'Quote request failed')
      return result
    }

    form.addEventListener('submit', async (event) => {
      event.preventDefault()
      const quoteConfig = getQuoteConfiguration()
      configuration.value = JSON.stringify(quoteConfig)

      const submit = form.querySelector('[type="submit"]')
      const originalText = submit?.innerHTML
      const customer = {
        name: section.querySelector('[data-quote-customer-name]')?.value?.trim() || '',
        email: section.querySelector('[data-quote-customer-email]')?.value?.trim() || '',
        whatsapp: section.querySelector('[data-quote-customer-whatsapp]')?.value?.trim() || ''
      }
      const payload = {
        source: 'ntkeee-product-customizer',
        submittedAt: new Date().toISOString(),
        customer,
        product: {
          title: section.dataset.productTitle || '',
          handle: section.dataset.productHandle || '',
          url: window.location.href.split('?')[0]
        },
        selection: quoteConfig
      }
      const whatsappPopup = openWhatsAppPlaceholder()

      if (submit) {
        submit.disabled = true
        submit.innerHTML = 'generating preview…<span>↗</span>'
      }
      setStatus('Generating preview images…')
      try {
        payload.previews = await buildQuotePreviews()
        if (submit) submit.innerHTML = 'sending quote request…<span>↗</span>'
        setStatus('Sending your quote request…')
        const result = await submitQuoteRequest(payload)
        if (result.fallback === 'whatsapp') {
          openWhatsAppQuoteReminder(payload, whatsappPopup)
          setStatus('WhatsApp is opening with your quote details. Please send the message there.')
        } else {
          openWhatsAppQuoteReminder(payload, whatsappPopup)
          setStatus('Quote request sent. WhatsApp is opening so you can send us a quick reminder.')
        }
      } catch (_error) {
        openWhatsAppQuoteReminder(payload, whatsappPopup)
        setStatus('The quote endpoint is not ready, so WhatsApp is opening with your quote details.')
      } finally {
        if (submit) {
          submit.disabled = false
          submit.innerHTML = originalText
        }
      }
    })

    cleanDetails()
    renderOptions(!galleryMode)
    if (galleryMode) renderGalleryImage(galleryThumbnails.find((thumbnail) => thumbnail.classList.contains('is-active')) || galleryThumbnails[0])

    // Shopify can temporarily serve cached Liquid product.media after Admin API image replacement.
    // Refresh the customizer map from the uncached product JSON endpoint so colour previews update immediately.
    const productHandle = section.dataset.productHandle || ''
    if (productHandle) {
      fetch(`/products/${encodeURIComponent(productHandle)}.js`, { credentials: 'same-origin' })
        .then((response) => response.ok ? response.json() : Promise.reject(new Error('Product media unavailable')))
        .then((product) => {
          const currentMedia = (product.media || [])
            .filter((item) => item.media_type === 'image' && item.src)
            .map((item) => ({ alt: item.alt || '', url: item.src }))
          if (!currentMedia.length) return
          media.splice(0, media.length, ...currentMedia)
          section.querySelectorAll('[data-option-kind="colour"] [data-customizer-option-value]').forEach((button) => {
            const colour = (button.dataset.customizerOptionValue || '').toLowerCase().replace(/\s+/g, ' ').trim()
            const front = media.find((item) => {
              const parts = getCustomizerParts(item)
              return parts[0] === 'customizer' && parts[1] === colour && parts[2] === 'front'
            })
            const image = button.querySelector('img')
            if (image && front?.url) image.src = front.url
          })
          if (!galleryMode) renderSide()
        })
        .catch(() => {})
    }
    if (window.gsap) {
      window.gsap.from(stage, { opacity: 0, scale: 0.94, duration: 0.8, ease: 'power3.out' })
      window.gsap.from(section.querySelectorAll('.product-customizer__control'), { opacity: 0, y: 18, duration: 0.5, stagger: 0.06, ease: 'power2.out' })
    }
  })
}

initialiseProductCustomizers()
document.addEventListener('shopify:section:load', (event) => initialiseProductCustomizers(event.target))
